import React, { useRouter } from 'next/router';
import { FaTwitter } from 'react-icons/fa';

import styles from './share.module.css';

const TwitterButton = ({ query }) => {
  return (
    <a
      className={`${styles.twitter} hover:shadow-lg focus:shadow-lg focus:outline-none focus:opacity-80 transition duration-200 ease`}
      href={`https://twitter.com/intent/tweet?${query}`}
      target="_blank"
      rel="noopener noreferrer"
    >
      <i>
        <FaTwitter />
      </i>
      Tweet
    </a>
  );
};
const Share = ({ articleName, feedback = true }) => {
  const router = useRouter();

  return (
    <div className={styles.container}>
      <hr className="w-full mb-8" />
      {feedback && (
        <>
          <h3 className="text-black font-medium">Was this article helpful?</h3>
          <div className={styles.buttons_container}>
            <button
              className={styles.button_positive}
              aria-label="positive feedback"
            >
              Yes, thanks!
            </button>
            <button
              className={styles.button_negative}
              aria-label="negative feedback"
            >
              Not really
            </button>
          </div>
        </>
      )}
      <div className={styles.twitter_container}>
        <p>Spread the word</p>
        <TwitterButton
          query={`text=${articleName}&url=${process.env.NEXT_PUBLIC_WEB_HOST}${router.asPath}&via=popsql`}
        />
      </div>
    </div>
  );
};

export default Share;
